import React, { useEffect } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import labelKey from '../../localization/label.json';
import EmailSetting from './EmailSetting';
import { PageTitle } from '../../../_metronic/layout/core';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import OrgSettingPages from './OrgSettingPages';
import CacheClearSetting from '../../modules/accounts/components/settings/cards/CacheClearSetting';
import VersionsSettings from './versionSettings/VersionsSettings';
import { useGetOrgServiceLookupQuery } from '../../../services/SystemSettingsApi';
import OrgSettingGroup from '../../modules/accounts/components/settings/cards/OrgSettingGroup';

const myReportBreadCrumbs = [
    {
        title: 'Org Settings',
        path: 'settings/org-settings/email-configuration',
        isSeparator: false,
        isActive: true,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: false,
        isActive: false,
    },

]
const OrgSettings = () => {
    const { data: getOrgServiceLookup, refetch } = useGetOrgServiceLookupQuery('');

    useEffect(() => {
        refetch()
    }, [refetch])

    return (
        <>
            <PageTitle breadcrumbs={[]}>{labelKey.configurationSetting}</PageTitle>
            <Routes>
                <Route
                    element={
                        <>

                            <OrgSettingPages getOrgServiceLookup={getOrgServiceLookup} />
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        path='email-configuration'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Email Configuration</PageTitle>
                                <EmailSetting />
                            </>
                        }
                    />
                    <Route
                        path='cache-clear'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Cache Clear Setting</PageTitle>
                                <CacheClearSetting />
                            </>
                        }
                    />
                    <Route
                        path='settings-group'
                        element={
                            <>
                                <PageTitle breadcrumbs={myReportBreadCrumbs}>Settings Group</PageTitle>
                                <OrgSettingGroup />
                            </>
                        }
                    />
                    {getOrgServiceLookup?.result?.map((data: any, index: any) => (
                        <Route
                            key={index}
                            path={data?.name.toLowerCase()}
                            element={
                                <>
                                    <PageTitle breadcrumbs={myReportBreadCrumbs}>{data?.name}</PageTitle>
                                    <VersionsSettings serviceId={data?.serviceId} />
                                </>
                            }
                        />
                    ))}
                    <Route index element={<Navigate to='/settings/org-settings/email-configuration' />} />
                </Route>
            </Routes>
        </>
    )
}

export default OrgSettings